
import { Injectable } from '@angular/core';
import { HttpService } from '../providers/http.service';
import { AppConfig } from '../app/app.config';
import { AlertService } from "./../providers/alert.service";

@Injectable()
export class SysconfigService {
    constructor(
        private httpService: HttpService,
        private alert: AlertService,
    ) { }


    //获取系统配置
    //TQQ 2017-01-10
    getSysconfig() {
        var url = AppConfig.GetProdUrl() + "/System/SysConfig";
        return this.httpService.get(url);
    }
    /**
 * 获取用户的声音开关设置
 */
    GetReminderSwitchers() {
        var url = AppConfig.GetProdUrl() + "/User/GetReminderSwitchers";
        return this.httpService.get(url);
    }
    /**
     * 设置用户的声音开关
     */
    SetReminderSwitchers(params) {
        var url = AppConfig.GetProdUrl() + "/User/SetReminderSwitchers";
        return this.httpService.post(url, params);
    }

    /**
     *获取后台signalr地址
     *sing 20181102
     * @returns
     * @memberof SignalrService
     */
    getSignalr() {
        let url = AppConfig.GetProdUrl() + "/User/GetSignalrUrl";
        return this.httpService.get(url);
    }

    getWechatSettings() {
        var url = AppConfig.GetProdUrl() + "/System/GetWxSettings";
        return this.httpService.get(url);
    }

    getPlatformLineList() {
        var url = AppConfig.GetProdUrl() + "/System/GetPlatformLineList";
        return this.httpService.get(url);
    }
    //获取微信客服二维码
    getkefuqrcode() {
        var url = AppConfig.GetProdUrl() + "/System/GetKefu";
        return this.httpService.get(url);
    }
    /**
     * 获取客服地址，不需要登陆就可以获得
     * David 2018-06-22
     */
    getServiceHall() {
        var url = AppConfig.GetProdUrl() + "/System/ServiceHall";
        return this.httpService.get(url);
    }
    /**
     * 获取首页轮播图
     * David 2018-09-28
     */
    getCarousel() {
        var url = AppConfig.GetProdUrl() + "/System/GetHomePic";
        return this.httpService.get(url);
    }
    /**
     * 获取活动内容
     * David 2018-09-28
     */
    getActive() {
        var url = AppConfig.GetProdUrl() + "/System/GetActivityContent";
        return this.httpService.get(url);
    }
    /**
    * 获取协议与条款
    * David 2018-09-28
    */
    getAgreement() {
        var url = AppConfig.GetProdUrl() + "/System/GetAgreement";
        return this.httpService.get(url);
    }

    /**
     *获取首页左上角logo
     *sing 2018-11-28
     * @returns
     * @memberof SysconfigService
     */
    getLogoPic() {
        var url = AppConfig.GetProdUrl() + "/System/GetLogoPic";
        return this.httpService.get(url);
    }

    /**
     * 获取六合彩换肖年份
     */
    getLiuhecaiHXYear() {
        var url = AppConfig.GetProdUrl() + "/Lottery/GetLiuhecaiHXYear";
        return this.httpService.get(url);
    }

    /**
     * 获取六合彩换肖年份、期号
     */
    MarksixSettings() {
        var url = AppConfig.GetProdUrl() + "/Lottery/MarksixSettings";
        return this.httpService.get(url);
    }

    /**
     * 获取清理indexDB标识
     */
    getCacheClean() {
        var url = AppConfig.GetProdUrl() + "/system/GetCacheClean";
        return this.httpService.get(url);
    }

    /**
     * 挂机软件地址配置
     */
    getHangonToolSettings() {
        var url = AppConfig.GetProdUrl() + "/System/GetHangonToolSettings";
        return this.httpService.get(url);
    }

    /**
      * 第三方挂机地址--云挂机---如果开启挂机了，才可查询此接口l
      */
    getHangonTool(params) {
        var url = AppConfig.GetProdUrl() + "/System/GoHangonTool";
        return this.httpService.post(url, params);
    }

    /**
     *  所有第三方游戏是否开启开关
     */
    getThirdIsOpen() {
        const url = AppConfig.GetProdUrl() + "/System/GetThirdIsOpen";
        return this.httpService.get(url);
    }

     /**
     *  获取三方游戏
     */
     getOpenGames() {
        const url = AppConfig.GetProdUrl() + "/System/GetOpenGames";
        return this.httpService.get(url);
    }

    /**
     * 获取彩种和它的官方网址
     *  rico 2019-06-17
     */
    GetLotteryWithOfficialWeb() {
        var url = AppConfig.GetProdUrl() + "/Lottery/GetLotteryWithOfficialWeb";
        return this.httpService.get(url);
    }
    /**
 * 获取维护页面信息
 */
    getMaintainSettings() {
        var url = AppConfig.GetProdUrl() + "/Log/GetMaintainSettings";
        return this.httpService.post(url, null);
    }


    // 立即注册
    register() {
        var url = AppConfig.GetProdUrl() + "/System/GetOpenRegister";
        return this.httpService.get(url);
    }
    /**
* 注册验证方式
*/
    getValidCodeType() {
        let url = AppConfig.GetProdUrl() + "/system/GetValidCodeType";
        return this.httpService.get(url);
    }
    /**
    * 验证滑块验证码是否正确
    */
    authSecurityCode(params) {
        let url = AppConfig.GetProdUrl() + "/auth/VerificationCheckSlider";
        return this.httpService.post(url, params);
    }
    /** 获取验证图片 */
    getSecurityCode(catchId) {
        let params = {
            width: 300, height: 150, catchId: catchId
        }
        let url = AppConfig.GetProdUrl() + "/auth/GetSlideValidImg";
        return this.httpService.get(url, params);
    }
}


// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./node_modules/angular2-template-loader!./node_modules/tslint-loader??ref--7-0!./src/services/sysconfig.service.ts